<script setup lang="ts">
import CardDialog from '@/components/dialogs/CardDialog.vue'
import { useSlots } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  /** Title of the confirm dialog */
  title?: string | null
}

const { title = null } = defineProps<Props>()

defineOptions({
  name: 'ConfirmDialog'
})

const { t } = useI18n()
const slots = useSlots()
</script>

<template>
  <CardDialog :title="title ?? t('general.confirm')">
    <template v-for="(slot, index) in Object.keys(slots)" :key="index" #[slot]>
      <slot :name="slot" />
    </template>
    <template #action>
      {{ t('general.confirm') }}
    </template>
  </CardDialog>
</template>
